import { render, staticRenderFns } from "./ProductBrandList.vue?vue&type=template&id=2d541719&scoped=true&"
import script from "./ProductBrandList.vue?vue&type=script&lang=js&"
export * from "./ProductBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d541719",
  null
  
)

export default component.exports